// VERSION: 1.0.0
// AUTHOR: AGALYA

/* eslint-disable import/no-anonymous-default-export */

import { docodeHexResponse } from '../../../_common/common.utils';
import BusinessLoanDisbursementActionTypes from './business-loan-disbursement.types';

const INITIAL_STATE = {
	// Fetch Business Loan Index
	getBusinessLoanIndexResponse: null,
	getBusinessLoanIndexArr: [],
	// Fetch Finance Based Account Type
	getFinanceBasedAccountResponse: null,
	getFinanceBasedAccountArr: [],
	// Business Loan Disbursement
	loanDisbursementResponse: null,

	// Fetch Business Loan Info
	fetchBusinessLoanInfoResponse: null,
	fetchBusinessLoanInfoArr: [],
	// Get Business List
	getBusinessListResponse: null,
	getBusinessListArr: [],
};

const businessLoanDisbursementReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/*** FETCH BUSINESS LOAN INDEX START ***/
		case BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INDEX_SUCCESS:
			return {
				...state,
				getBusinessLoanIndexResponse: action.payload,
				getBusinessLoanIndexArr: docodeHexResponse(
					action.payload,
					'FetchBusinessLoanIndexDetails',
				),
			};

		case BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INDEX_FAILURE:
			return { ...state, getBusinessLoanIndexResponse: action.payload };

		case BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INDEX_RESPONSE_CHANGED:
			return { ...state, getBusinessLoanIndexResponse: null };
		/*** FETCH BUSINESS LOAN INDEX END ***/

		/*** FETCH FINANCE BASED ACCOUNT TYPE START ***/
		case BusinessLoanDisbursementActionTypes.FETCH_FINANCE_BASED_ACCOUNT_TYPE_SUCCESS:
			return {
				...state,
				getFinanceBasedAccountResponse: action.payload,
				getFinanceBasedAccountArr: docodeHexResponse(
					action.payload,
					'GetFinanceBasedTypeListKey',
				),
			};

		case BusinessLoanDisbursementActionTypes.FETCH_FINANCE_BASED_ACCOUNT_TYPE_FAILURE:
			return { ...state, getFinanceBasedAccountResponse: action.payload };

		case BusinessLoanDisbursementActionTypes.FETCH_FINANCE_BASED_ACCOUNT_TYPE_RESPONSE_CHANGED:
			return { ...state, getFinanceBasedAccountResponse: null };

		/*** FETCH FINANCE BASED ACCOUNT TYPE END ***/

		/*** BUSINESS LOAN DISBURSEMENT START ***/
		case BusinessLoanDisbursementActionTypes.BUSINESS_LOAN_DISBURSEMENT_SUCCESS:
			return {
				...state,
				loanDisbursementResponse: action.payload,
			};

		case BusinessLoanDisbursementActionTypes.BUSINESS_LOAN_DISBURSEMENT_FAILURE:
			return { ...state, loanDisbursementResponse: action.payload };

		case BusinessLoanDisbursementActionTypes.BUSINESS_LOAN_DISBURSEMENT_RESPONSE_CHANGED:
			return { ...state, loanDisbursementResponse: null };

		/*** BUSINESS LOAN DISBURSEMENT END ***/

		/*** FETCH BUSINESS LOAN INFO DETAILS START ***/
		case BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INFO_DETAILS_SUCCESS:
			return {
				...state,
				fetchBusinessLoanInfoResponse: action.payload,
				fetchBusinessLoanInfoArr: docodeHexResponse(
					action.payload,
					'GetBusinessLoanInfoKey',
				),
			};

		case BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INFO_DETAILS_FAILURE:
			return { ...state, fetchBusinessLoanInfoResponse: action.payload };

		case BusinessLoanDisbursementActionTypes.FETCH_BUSINESS_LOAN_INFO_DETAILS_RESPONSE_CHANGED:
			return { ...state, fetchBusinessLoanInfoResponse: null };
		/*** FETCH BUSINESS LOAN INFO DETAILS END ***/

		/*** GET BUSINESS LIST START ***/

		case BusinessLoanDisbursementActionTypes.GET_BUSINESS_LIST_SUCCESS:
			return {
				...state,
				getBusinessListResponse: action.payload,
				getBusinessListArr: docodeHexResponse(action.payload, 'GetBusinessDataListKey'),
			};

		case BusinessLoanDisbursementActionTypes.GET_BUSINESS_LIST_FAILURE:
			return { ...state, getBusinessListResponse: action.payload };

		case BusinessLoanDisbursementActionTypes.GET_BUSINESS_LIST_RESPONSE_CHANGED:
			return { ...state, getBusinessListResponse: null };

		/*** GET BUSINESS LIST END ***/

		default:
			return state;
	}
};

export default businessLoanDisbursementReducer;
